import MindsetsJsSDK from "../../index";
import {LoadingAction} from "../layout/actions";
import {ErrorMessageAction, SuccessMessageAction} from "../components/CustomToast/actions";

export const LOADED_SCHOOLS = '[schools] Loaded Schools';
export const LOADED_SCHOOLS_PAGES = '[schools] Loaded pages';
export const LOADED_SCHOOLS_TOTAL = '[schools] Loaded total';
export const LOADED_SCHOOLS_CURRENT = '[schools] Loaded current';
export const LOADED_SCHOOLS_LIMIT = '[schools] Loaded limit';
export const SET_SCHOOL = '[school] Set School';

export const LoadSchoolsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Schools')))
        .then(() => MindsetsJsSDK().API.get('schools', options))
        .then(response => {
            dispatch(LoadedSchoolsAction(response.items));
            dispatch(LoadedSchoolsCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedSchoolsLimitAction(response.limit));
            dispatch(LoadedSchoolsPagesAction(response.pages));
            dispatch(LoadedSchoolsTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedSchoolsAction = payload => ({
    type: LOADED_SCHOOLS,
    payload
});
export const LoadedSchoolsPagesAction = payload => ({
    type: LOADED_SCHOOLS_PAGES,
    payload
});
export const LoadedSchoolsTotalAction = payload => ({
    type: LOADED_SCHOOLS_TOTAL,
    payload
});
export const LoadedSchoolsCurrentAction = payload => ({
    type: LOADED_SCHOOLS_CURRENT,
    payload
});
export const LoadedSchoolsLimitAction = payload => ({
    type: LOADED_SCHOOLS_LIMIT,
    payload
});

export const LoadSchoolAction = (school_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading School')))
        .then(() => MindsetsJsSDK().API.get('schools/' + school_id, options))
        .then(response => {
            dispatch(SetSchoolAction(response.school));
            dispatch(LoadingAction(false));

            return response.school;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const SetSchoolAction = payload => ({
    type: SET_SCHOOL,
    payload
});
export const CreateSchoolAction = (data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Creating School')))
        .then(() => MindsetsJsSDK().API.post('schools', data, options))
        .then(response => {
            dispatch(LoadingAction(false));
            dispatch(SuccessMessageAction('New School has been created.'));

            return response.school;
        });
};
export const UpdateSchoolAction = (id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Updating School')))
        .then(() => MindsetsJsSDK().API.put(`schools/${id}`, data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('School has been updated.')));
};
export const DeleteSchoolAction = (school_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.delete(`schools/${school_id}`, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('School deleted')))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};

export const CreateSchoolSubscriptionAction = (school_id, data, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Creating School')))
        .then(() => MindsetsJsSDK().API.post(`schools/${school_id}/subscriptions`, data, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('New School Subscription has been created.')))
        .then(() => dispatch(LoadSchoolAction(school_id)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const DeleteSchoolSubscriptionAction = (school_id, subscription_id, options) => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Creating School')))
        .then(() => MindsetsJsSDK().API.delete(`schools/${school_id}/subscriptions/${subscription_id}`, options))
        .then(() => dispatch(LoadingAction(false)))
        .then(() => dispatch(SuccessMessageAction('School Subscription has been deleted.')))
        .then(() => dispatch(LoadSchoolAction(school_id)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};

export const CheckSchoolExistsAction = (data, options) => dispatch => {
    dispatch(LoadingAction(true, 'Checking school'));

    return MindsetsJsSDK().API.post('schools/check', data, options)
        .then(response => {
            dispatch(LoadingAction(false));
            if (response.schools.length > 0) {
                dispatch(LoadedSchoolsAction(response.schools));
                return false;
            }

            return true;
        });
}

export const LoadMySchoolsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Schools')))
        .then(() => MindsetsJsSDK().API.get('me/schools', options))
        .then(response => {
            dispatch(LoadedSchoolsAction(response.schools));
            dispatch(LoadingAction(false));

            return response.schools;
        });
};
